import React, { useRef, useState } from 'react';

import styled from 'styled-components';

import { Plus } from 'assets/assetsV1/iconComponents';
import NoDataImage from 'assets/images/illustrations/NoData.png';

import theme from 'constants/theme';

import { Typography14, Typography16 } from 'uiToolkit/Typography';
import { Button } from 'uiToolkitV1/Button';

const Container = styled.div`
  background: white;
  width: 100%;
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: stretch;
`;

const GroupingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Image = styled.img`
  width: 280px;
  height: auto;
`;

const NoData = ({ onAddKR = () => {}, onAddObjective = () => {}, showSubTitle = true }) => {
  const [isMenuOpen, setMenuIsOpen] = useState(false);
  const anchorRef = useRef();

  return (
    <Container>
      <GroupingContainer>
        <Image src={NoDataImage} />
        <Typography16 weight={600} color={theme.palette.text.blackv1} bottomGutter={2}>
          There's no data available
        </Typography16>
        {showSubTitle && (
          <Typography14 bottomGutter={2}>
            There was a truly profound insight, but there wasn't enough data so let's not talk about it.
          </Typography14>
        )}

        <Button variant="rowButtonFilled" StartIcon={Plus} onClick={onAddObjective} pt="2px">
          Add New Goal
        </Button>
      </GroupingContainer>
    </Container>
  );
};

export default NoData;
